<template>
  <td class="row-column" v-if="collapsibleSelectionEnabled"></td>
  <td :colspan="columnsContentCount" class="row-column"></td>
  <td v-if="collapsibleButtonShow" class="row-column">
    <div class="wrapper">
      <div class="column-collapsible">
        <a type="button" class="btn float-right" @click.prevent="collapsibleButtonOnClicked(props.id, props.index)"
          :title="collapsibleButtonStateIsOpen ? collapsibleButtonStateIsOpenMessage : collapsibleButtonStateIsClosedMessage">
          <i v-if="collapsibleButtonStateIsOpen" class="eii--fa6-solid--square-minus"></i>
          <i v-if="!collapsibleButtonStateIsOpen" class="eii--fa6-solid--square-plus"></i>
        </a>
      </div>
    </div>
  </td>
</template>

<script setup lang="ts">
import { DefinitionListContentColumn, DataListRowEntityEntry, DefinitionListContentConfiguration, DataListLookup, DefinitionListContentConfigurationSelection } from '@/components/types'

import { useCollapsible } from '@/components/ListRowColumnBody/collapsible'

interface Props {
  columns: DefinitionListContentColumn[]
  config: DefinitionListContentConfiguration
  lookups: DataListLookup[]
  entry: DataListRowEntityEntry
  selection: DefinitionListContentConfigurationSelection
  id: string | number
  index: string | number
  columncount: number,
  entity: string
}

const props = withDefaults(defineProps<Props>(), {
  columns: undefined,
  config: undefined,
  lookups: undefined,
  entry: undefined,
  selection: undefined,
  id: undefined,
  index: undefined,
  columncount: undefined,
  entity: undefined
})

const emit = defineEmits(['hcl-list-row-column-body-collapsible-clicked'])

const collapsibleButtonOnClicked = (id: string | number, index: string | number) => {
  emit('hcl-list-row-column-body-collapsible-clicked', { id: id, index: index })
}

const {
  collapsibleButtonShow,
  collapsibleButtonStateIsOpen,
  collapsibleButtonStateIsOpenMessage,
  collapsibleButtonStateIsClosedMessage,
  collapsibleSelectionEnabled,
  columnsContentCount
} = useCollapsible(props)
</script>
